import GuitarNote from "./entities/notes/guitarNote";
import BatteryNote from "./entities/notes/batteryNote";
import SingerNote from "./entities/notes/singerNote";
import BassNote from "./entities/notes/bassNote";
import * as Tone from 'tone';

const synths = [];
export default function({engine, midi, delay, playsound}){
    while (synths.length) {
        const synth = synths.shift();
        synth.disconnect();
    }
    if (midi) {
        let index = 0;
        midi.tracks.forEach((track) => {

            let synth = null;
            if(playsound){
                //create a synth for each track
                synth = new Tone.PolySynth(Tone.Synth, {
                    envelope: {
                        attack: 0.02,
                        decay: 0.1,
                        sustain: 0.3,
                        release: 1,
                    },
                }).toDestination();
                synths.push(synth);
            }

            //schedule all of the events
            track.notes.forEach((note) => {
                note.time += delay;
                if(playsound){
                    synth.triggerAttackRelease(
                        note.name,
                        note.duration,
                        note.time + Tone.now(),
                        note.velocity
                    );
                }
                //create notes entities based on the midi track index
                switch(index){
                    case 3: new BassNote({ engine, note}); break;
                    case 4: new BatteryNote({ engine, note}); break;
                    case 5: new SingerNote({ engine, note}); break;
                    default: new GuitarNote({ engine, note, track: index }); break;
                }
            });

            index++;
        });
    }
    
}

